import { fetchGroups } from '../actions/groupActions';

export interface Group {
  id: number;
  name: string;
}

const initialState = {
  groups: [] as Group[],
};

export const group = (state = initialState, action) => {
  switch (action.type) {
    case fetchGroups.success:
      return {
        ...state,
        groups: action.payload,
      };
    default:
      return state;
  }
};
